import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardVideoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22Z"
        fill={color}
      />
      <path
        d="M17 11.13L10 7.12999C9.37003 6.73999 8.48003 7.24999 8.50003 7.99999V16C8.48003 16.74 9.36003 17.26 10 16.87L17 12.87C17.66 12.52 17.66 11.48 17 11.13ZM10.5 14.28V9.72999L14.48 12.01L10.5 14.29V14.28Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardVideoIcon.displayName = 'BoardVideoIcon';
